import script from "./EmployeeBenefitsExpense.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeBenefitsExpense.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeBenefitsExpense.vue?vue&type=style&index=0&id=2df46b7d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2df46b7d"]])

export default __exports__